import { render, staticRenderFns } from "./FinanceiroIcon.vue?vue&type=template&id=af1588ce&"
import script from "./FinanceiroIcon.vue?vue&type=script&lang=ts&"
export * from "./FinanceiroIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports